import queryString from 'query-string'
import _ from 'lodash'
import { SimpleHeader } from './Header'
import PageError from './PageError'
import errorHelper from '../../../lib/errorHelper'
import { SilentPageProvider } from '../../context/silentPageContext'

const ErrorPage = ({ code, message, location = {} }) => {
  const parsed = queryString.parse(_.get(location, 'search', {}))
  const errorCode = code || parsed.code || ''
  const error = { code: errorCode, message }
  const apiErrorMappedMessage = errorHelper.parseErrorMessage(error)
  const errorMessage = message || apiErrorMappedMessage || _.get(location, 'state.errorMessage', '系統發生錯誤！')

  return (
    <SilentPageProvider>
      <>
        <div className='pure-u-1'>
          <SimpleHeader />
        </div>
        <div className={'pure-u-1'}>
          <PageError
            errorMessage={`${errorCode} ${errorMessage}`}
            enableHomeLink
          />
        </div>
      </>
    </SilentPageProvider>
  )
}

export default ErrorPage
